import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/components/notifications/notifications-page";

export const Route = createFileRoute("/admin/_layout/notifications")({
  component: () => <NotificationsPage audience="ADMIN" />,
});
